import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const DropsOverviewPage = lazy(
  () =>
    import('./DropsOverviewPage.eager').then(mod => ({
      default: mod.DropsOverviewPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
